import { ISolaceConsumer } from '../types/ISolaceConsumer'

export class SolaceConsumer implements ISolaceConsumer {
	public session: any;
	public queueName: string = '';
	public topicName: string = '';
	public consuming: boolean = false;
	public messageConsumer: any;
	log(line: string): void {
		throw new Error('Method not implemented.');
	}
	run(): void {
		throw new Error('Method not implemented.');
	}
	connect(): void {
		throw new Error('Method not implemented.');
	}
	startConsume(): void {
		throw new Error('Method not implemented.');
	}
	exit(): void {
		throw new Error('Method not implemented.');
	}
	stopConsume(): void {
		throw new Error('Method not implemented.');
	}
	disconnect(): void {
		throw new Error('Method not implemented.');
	}
	publish(payload:any): void {
		throw new Error('Method not implemented.');
	}
	connectToSolace(): void {
		throw new Error('Method not implemented.');
	}
}
